<template>
  <div class="my-order all-order-content public-content">
    <div class="breadcrumb">{{ '查看' + (isPick ? '选片' : '收片') }}</div>
    <div class="right-content" style="margin-top:20px;">
      <!-- <div class="main-content"> -->
      <el-form hide-required-asterisk ref="addForm" :model="addForm" style="padding-right:20px;" label-width="125px" :rules="rules" class="form">
        <el-form-item :label="isPick ? '选片名称' : '收片名称'" prop="name"> {{ addForm.name }} <!-- <el-button v-if="!isEdit" round @click="$refs.SelectTemplate.show()">选择模板</el-button> -->
          <!-- <el-button v-if="!isEdit" round @click="saveAsTemplateName='',saveAsDialog=true">另存为模板</el-button> -->
        </el-form-item>
        <!-- 多模板页 -->
        <el-form-item label="已选择模板" v-if="!isSingle && selectedTemplate.templateId"> {{ selectedTemplate.name }} </el-form-item>
        <el-form-item label="模板页信息" prop="templateId" v-if="!isSingle">
          <el-table :data="selectedTemplate.modulees" class="table-cell" border style="width: 100%">
            <el-table-column prop="name" label="模板页名称" width="200px"></el-table-column>
            <el-table-column prop="infoStr" label="需填信息"></el-table-column>
          </el-table>
        </el-form-item>
        <!-- 单模板页 -->
        <el-form-item label="模板页名称" v-show="isSingle">
          <span>{{ singleModuleName }}</span>
        </el-form-item>
        <el-form-item label="模板页信息" v-if="isSingle" prop="singleModuleInfoList">
          <el-table :data="singleModuleInfoList" ref="singleModuleInfoList" class="table-cell" border style="width: 610px;">
            <el-table-column label="模板页信息" width="200px">
              <template slot-scope="scope">
                <span>{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="infoValue" label="限制">
              <template slot-scope="scope">
                <span v-if="scope.row.infoType === 'TEXT'">长度:{{ scope.row.infoValue }}</span>
                <span v-if="scope.row.infoType === 'IMAGE'">数量:{{ scope.row.infoValue }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="选片人数" prop="limitPerson"> {{ addForm.limitPerson }} </el-form-item>
        <el-form-item label="开始日期">
          <span>{{ addForm.dateStart }}</span>
          <el-form-item label="结束日期" prop="dateEnd" style="display:inline-block;"> {{ addForm.dateEnd }} </el-form-item>
        </el-form-item>
        <el-form-item label="公共照片" v-if="isPick">
          <Public ref="Public" />
        </el-form-item>
        <el-form-item label="个人照片" v-if="isPick && perLock">
          <Personal ref="Personal" v-show="perLock" />
        </el-form-item>
        <el-form-item>
          <div class="function">
            <el-button type="primary" style="float:right;" @click="$router.go(-1)" round>返回</el-button>
          </div>
        </el-form-item>
      </el-form>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import { templateQueryById, adminTaskDetail } from '@/api/auxx.js'
import Public from './public.vue'
import Personal from './personal.vue'

export default {
  components: {
    Public, Personal
  },
  data () {
    var singleModuleInfoList = (rule, value, callback) => {
      if (this.moduleInfoSelection.length === 0) {
        callback(new Error('请选择模板页信息'))
      } else {
        let lock = false
        let imgLock = false
        let nameLock = false

        this.moduleInfoSelection.some(item => {
          if (item.infoType === 'TEXT' && item.infoValue && !/[^\d]/g.test(item.infoValue)) {

          } else if (item.infoType === 'IMAGE' && item.min && !/[^\d]/g.test(item.min) && item.max && !/[^\d]/g.test(item.max)) {
            if (+item.min > +item.max) {
              imgLock = true
            }
          } else {
            lock = true
          }
          if (!item.name) {
            nameLock = true
          }
        })

        if (lock) {
          callback(new Error('请输入限制，格式为整数'))
        } else if (imgLock) {
          callback(new Error('最大图片数不能小于最小图片数'))
        } else if (nameLock) {
          callback(new Error('请输入模板页信息名称'))
        } else {
          callback()
        }
      }
    }
    return {
      addLock: false,
      isEdit: false,
      isPick: false,
      isSingle: true,
      saveAsDialog: false,
      saveAsTemplateName: '',
      singleModuleName: '',
      singleModuleInfoList: [],
      moduleInfoSelection: [],
      pickerOptions: {
        disabledDate: (time) => {
          let pickTime = time.getTime()
          let nowTime = new Date().getTime()
          if (pickTime >= nowTime && pickTime <= nowTime + 31 * 24 * 60 * 60 * 1000) {
            return false
          } else {
            return true
          }
        }
      },
      name: '',
      intro: '',
      limitPerson: '',
      precent: {},
      perLock: false,
      selectedTemplate: {},
      userList: [],
      tableList: [],
      dateEnd: '',
      addForm: {
        completed: false,
        dateEnd: '',
        dateStart: '',
        intro: 'aaa',
        imageForms: [],
        limitPerson: '',
        name: '',
        pickNum: 0,
        taskType: '',
        templateId: '',
        templateName: ''
      },
      value1: [],
      value2: [],
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      rules: {
        name: [
          { required: true, message: '请输入选片名称', trigger: 'blur' }
        ],
        intro: [
          { required: true, message: '请输入选片简介', trigger: 'blur' }
        ],
        templateId: [
          { required: true, message: '请选择模板', trigger: 'blur' }
        ],
        singleModuleInfoList: [
          { validator: singleModuleInfoList, trigger: 'change' }
        ],
        limitPerson: [
          { required: true, message: '请输入选片人数', trigger: 'blur' },
          { type: 'number', message: '年龄必须为数字值' }
        ],
        dateEnd: [
          { required: true, message: '请选择结束日期', trigger: 'change' }
        ]
      }

    }
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.isEdit = !!this.$route.query.id
        this.isPick = this.$route.query.type === 'pick'
        this.addForm.taskType = this.$route.query.type === 'pick' ? 'PICK' : 'COLL'
        this.initTask()
      },
      // 深度观察监听
      deep: true,
      immediate: true
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {

  },
  methods: {
    saveAs () {
      if (!this.saveAsTemplateName) {
        this.$notify({
          title: '警告',
          message: '请输入模板名称',
          type: 'error'
        })
        return
      }
      this.selectedTemplate.saveAs = true
      this.selectedTemplate.name = this.saveAsTemplateName
      this.saveAsDialog = false
    },
    addModuleInfo () {
      let obj = {
        infoType: 'TEXT',
        infoValue: '',
        name: ''
      }
      this.singleModuleInfoList.splice(-1, 0, obj)
    },
    handleSelectionChange (val) {
      this.moduleInfoSelection = val
    },

    initTask () {
      adminTaskDetail(this.$route.query.id)
        .then(res => {
          if (res.data.success) {
            let data = res.data.data
            data.dateStart = data.dateStart.split(' ')[0]
            data.dateEnd = data.dateEnd.split(' ')[0]
            this.addForm = data
            this.name = res.data.data.name
            this.intro = res.data.data.intro
            this.limitPerson = res.data.data.limitPerson
            this.dateEnd = res.data.data.dateEnd
            this.getTemplateDetail(res.data.data.templateId)
            this.initImg(res.data.data.images)
          }
        })
    },
    initImg (images) {
      let imgObj = {
        '': []
      }
      images.forEach(img => {
        imgObj[img.image.tags] = imgObj[img.image.tags] ? imgObj[img.image.tags] : []
        imgObj[img.image.tags].push({
          isNew: false,
          src: img.image.url,
          imgDetail: {},
          smallSrc: img.image.url + '?x-sds-process=image/resize,l_200,m_mfit',
          file: '',
          name: img.image.url,
          uploadedSrc: img.image.url
        })
      })

      this.$refs.Public.init(imgObj[''])
      let perList = []
      Object.keys(imgObj).forEach(name => {
        if (name === '') {
          return
        }
        let obj = {
          remark: name,
          name: name,
          userName: name,
          images: imgObj[name]
        }
        perList.push(obj)
      })

      if (perList.length !== 0) {
        this.perLock = true
        this.$nextTick(_ => {
          this.$refs.Personal.init(perList)
        })
      }
    },
    getTemplateDetail (id) {
      templateQueryById(id)
        .then(res => {
          if (res.data.success) {
            this.selected(res.data.data)
          }
        })
    },
    selected (val) {
      val.modulees = val.templateModuleXrefs.reduce((list, item) => {
        list[item.sorting - 1] = item.module
        return list
      }, [])
      console.log(val)
      if (val.templateModuleXrefs.length === 1) {
        this.isSingle = true
        this.addForm.templateId = ''
        this.addForm.templateName = ''
        let infolist = []
        // let imgRow = false
        val.modulees[0].moduleInfoXrefs.forEach(info => {
          let obj = {
            infoType: info.infoType,
            infoValue: info.infoValue,
            name: info.refInfo.name,
            min: info.infoType === 'IMAGE' && info.infoValue.split('-')[0],
            max: info.infoType === 'IMAGE' && info.infoValue.split('-')[1]
          }
          // if (info.infoType === 'IMAGE') {
          //   // imgRow = obj
          // } else {
          infolist.push(obj)
          // }
        })
        // imgRow && infolist.push(imgRow)
        this.singleModuleInfoList = infolist

        // imgRow && this.$nextTick(_ => {
        //   this.$refs.singleModuleInfoList.toggleRowSelection(this.singleModuleInfoList[this.singleModuleInfoList.length - 1])
        // })
        this.$nextTick(_ => {
          this.toggleSelection()
        })

        this.singleModuleName = val.modulees[0].name

        let temp = {
          modulees: [{
            moduleInfoVos: [],
            name: val.modulees[0].name
          }],
          name: val.name,
          saveAs: false,
          storeId: this.$store.state.user.storeId,
          themeId: val.themeId
        }

        this.selectedTemplate = temp
      } else {
        let temp = JSON.parse(JSON.stringify(val))
        temp.modulees.forEach(module => {
          let str = ''
          module.moduleInfoXrefs.forEach(info => {
            if (info.infoType === 'TEXT') {
              str += info.refInfo.name + '：文本长度' + info.infoValue + ' ; '
            } else if (info.infoType === 'IMAGE') {
              str += info.refInfo.name + '：照片数量' + info.infoValue + ' ; '
            }
          })
          module.infoStr = str
        })

        this.selectedTemplate = temp
        this.isSingle = false
        this.addForm.templateId = temp.templateId
        this.addForm.templateName = temp.name
        this.$refs.addForm.validateField('templateId')
      }
    },
    // 选中所有
    toggleSelection () {
      this.singleModuleInfoList.forEach(item => {
        this.$refs.singleModuleInfoList.toggleRowSelection(item)
      })
    }
    // onSubmit () {
    //   this.$refs.addForm.validate((valid) => {
    //     if (!valid) {
    //       return
    //     }

    //     if (+this.limitPerson > +this.addForm.limitPerson) {
    //       this.$notify({
    //         title: '失败',
    //         message: '人数只能大于原人数',
    //         type: 'error'
    //       })
    //       return
    //     }
    //     if (this.addLock) {
    //       this.$message.error('正在保存，请稍后')
    //       return
    //     }
    //     this.addLock = true

    //     if (this.isPick) {
    //       this.uploadImg()
    //     } else {
    //       this.saveColl()
    //     }
    //     // this.addForm.imageForms = [...this.$refs.Public.getInfo()]
    //   })
    // },

    // saveColl () {
    //   if (this.$route.query.id) {
    //     let form = {
    //       completed: this.addForm.completed,
    //       dateEnd: this.addForm.dateEnd + ' 23:59:59',
    //       dateStart: this.addForm.dateStart + ' 00:00:00',
    //       imageForms: [],
    //       intro: this.addForm.intro,
    //       limitPerson: this.addForm.limitPerson,
    //       name: this.addForm.name,
    //       pickNum: 0,
    //       taskType: this.addForm.taskType,
    //       templateId: this.addForm.templateId,
    //       templateName: this.addForm.templateName
    //     }
    //     taskEdit({ taskId: this.addForm.taskId, form: form })
    //       .then(res => {
    //         if (res.data.success) {
    //           this.$notify({
    //             title: '成功',
    //             message: '保存成功',
    //             type: 'success'
    //           })
    //           this.addLock = false

    //           this.$router.go(-1)
    //         }
    //       })
    //   } else {
    //     if (this.isSingle) {
    //       let templateVo = JSON.parse(JSON.stringify(this.selectedTemplate))
    //       templateVo.modulees[0].moduleInfoVos = this.moduleInfoSelection
    //       templateVo.modulees[0].name = this.singleModuleName
    //       templateSaveDefault(templateVo)
    //         .then(res => {
    //           if (res.data.success) {
    //             this.addForm.templateId = res.data.data.templateId
    //             this.addForm.templateName = res.data.data.name
    //             let addVo = JSON.parse(JSON.stringify(this.addForm))
    //             addVo.dateStart += ' 00:00:00'
    //             addVo.dateEnd += ' 23:59:59'
    //             taskAdd(addVo)
    //               .then(res => {
    //                 if (res.data.success) {
    //                   this.$notify({
    //                     title: '成功',
    //                     message: '新建成功',
    //                     type: 'success'
    //                   })
    //                   this.addLock = false

    //                   this.$router.go(-1)
    //                 }
    //               })
    //           }
    //         })
    //     } else {
    //       let addVo = JSON.parse(JSON.stringify(this.addForm))
    //       addVo.dateStart += ' 00:00:00'
    //       addVo.dateEnd += ' 23:59:59'
    //       taskAdd(addVo)
    //         .then(res => {
    //           if (res.data.success) {
    //             this.$notify({
    //               title: '成功',
    //               message: '新建成功',
    //               type: 'success'
    //             })
    //             this.addLock = false

    //             this.$router.go(-1)
    //           }
    //         })
    //     }
    //   }
    // },

    // // 上传图片
    // uploadImg () {
    //   let list = this.perLock ? [...this.$refs.Public.getList(), ...this.$refs.Personal.getList()] : [...this.$refs.Public.getList()]

    //   if (list.length === 0) {
    //     this.save(list)
    //     return
    //   }

    //   let loadingList = []
    //   this.precent = {}

    //   list.forEach(user => {
    //     console.log(user)
    //     this.precent[user.name] = []
    //     loadingList.push({
    //       userName: user.name === 'aux' ? '公共照片' : user.name,
    //       progress: 0,
    //       status: '上传中'
    //     })
    //     user.images.forEach(img => {
    //       this.precent[user.name].push({
    //         name: user.name + img.name,
    //         loaded: img.isNew && img.uploadedSrc !== '' ? 0 : 100,
    //         total: img.isNew && img.uploadedSrc !== '' ? 100 : img.file.size
    //       })
    //     })
    //   })

    //   this.$refs.loading.show('选片', loadingList)

    //   let userEnd = 0
    //   list.forEach(user => {
    //     let imgEnd = 0

    //     user.images.forEach(img => {
    //       if (img.isNew && img.uploadedSrc === '') {
    //         uploadChooseImage(img.file, this.$store.state.awsSdk.normal.s3, [], (e) => {
    //           this.changeLoading(e, user.images.length, user.name, user.name + img.name)
    //         })
    //           .then(res => {
    //             if (res === 'error') {
    //               this.$refs.loading.change(user.remark, 0, 'fail')
    //               return
    //             }

    //             img.uploadedSrc = res

    //             imgEnd++
    //             if (imgEnd === user.images.length) {
    //               userEnd++
    //               if (userEnd === list.length) {
    //                 this.save(list)
    //               }
    //             }
    //           })
    //       } else {
    //         setTimeout(_ => {
    //           this.changeLoading(img.uploadedSrc, user.images.length, user.name, user.name + img.name)
    //           imgEnd++
    //           if (imgEnd === user.images.length) {
    //             userEnd++
    //             if (userEnd === list.length) {
    //               this.save(list)
    //             }
    //           }
    //         }, 0)
    //       }
    //     })
    //   })
    // },
    // save (list) {
    //   let imageForms = []
    //   let newImageForms = []
    //   list.forEach(user => {
    //     let tag = user.userName === 'aux' ? '' : user.userName
    //     user.images.forEach(img => {
    //       let obj = {
    //         moduleId: 0,
    //         moduleName: '',
    //         tags: tag,
    //         title: '',
    //         url: img.uploadedSrc
    //       }

    //       img.isNew && newImageForms.push(obj)

    //       imageForms.push(obj)
    //     })
    //   })

    //   if (this.$route.query.id) {
    //     let form = {
    //       completed: this.addForm.completed,
    //       dateEnd: this.addForm.dateEnd + ' 23:59:59',
    //       dateStart: this.addForm.dateStart + ' 00:00:00',
    //       imageForms: newImageForms,
    //       intro: this.addForm.intro,
    //       limitPerson: this.addForm.limitPerson,
    //       name: this.addForm.name,
    //       pickNum: 0,
    //       taskType: this.addForm.taskType,
    //       templateId: this.addForm.templateId,
    //       templateName: this.addForm.templateName
    //     }
    //     taskEdit({ taskId: this.addForm.taskId, form: form })
    //       .then(res => {
    //         if (res.data.success) {
    //           this.$notify({
    //             title: '成功',
    //             message: '保存成功',
    //             type: 'success'
    //           })
    //           this.addLock = false

    //           this.$router.go(-1)
    //         }
    //       })
    //   } else {
    //     if (this.isSingle) {
    //       let templateVo = JSON.parse(JSON.stringify(this.selectedTemplate))
    //       templateVo.modulees[0].moduleInfoVos = this.moduleInfoSelection
    //       templateVo.modulees[0].name = this.singleModuleName
    //       templateSaveDefault(templateVo)
    //         .then(res => {
    //           if (res.data.success) {
    //             this.addForm.templateId = res.data.data.templateId
    //             this.addForm.templateName = res.data.data.name
    //             let vo = JSON.parse(JSON.stringify(this.addForm))
    //             vo.dateStart += ' 00:00:00'
    //             vo.dateEnd += ' 23:59:59'
    //             vo.imageForms = imageForms
    //             taskAdd(vo)
    //               .then(res => {
    //                 if (res.data.success) {
    //                   this.$notify({
    //                     title: '成功',
    //                     message: '新建成功',
    //                     type: 'success'
    //                   })
    //                   this.addLock = false

    //                   this.$router.go(-1)
    //                 }
    //               })
    //           }
    //         })
    //     } else {
    //       let vo = JSON.parse(JSON.stringify(this.addForm))
    //       vo.dateStart += ' 00:00:00'
    //       vo.dateEnd += ' 23:59:59'
    //       vo.imageForms = imageForms
    //       taskAdd(vo)
    //         .then(res => {
    //           if (res.data.success) {
    //             this.$notify({
    //               title: '成功',
    //               message: '新建成功',
    //               type: 'success'
    //             })
    //             this.addLock = false

    //             this.$router.go(-1)
    //           }
    //         })
    //     }
    //   }
    // },
    // changeLoading (e, length, userName, name) {
    //   this.precent[userName].forEach(item => {
    //     if (item.name === name) {
    //       if (typeof e === 'string') {
    //         item.loaded = 100
    //       } else {
    //         item.loaded = e.loaded
    //         item.total = item.total !== e.total ? e.total : item.total
    //       }
    //     }
    //   })
    //   let loaded = 0
    //   let total = 0
    //   this.precent[userName].forEach(item => {
    //     total += item.total
    //     loaded += item.loaded
    //   })
    //   if (userName === '王云腾') {
    //     console.log(Math.floor(loaded / total * 100), JSON.parse(JSON.stringify(this.precent[userName])))
    //   }

    //   this.$refs.loading.change(userName === 'aux' ? '公共照片' : userName, Math.floor(loaded / total * 100))
    // }
  }
}
</script>
<style lang="less" scoped>
@deep: ~">>>";

.main-content {
  background-color: #fafafa;
  padding: 20px 44px 20px 0;

  .el_input {
    width: 496px;

    @{deep} .el-input__inner {
      border: 1px solid #6d6d6d;
      border-radius: 7px;
    }
  }

  .table-cell {
    margin-top: 22px;

    .action_btn {
      display: block;
      width: 89px;
      height: 22px;
      border-radius: 22px;
      background: #f2f2f2;
      border: 1px solid #cccccc;
      font-size: 12px;
      font-family: Source Han Sans CN, Source Han Sans CN-Light;
      font-weight: 300;
      text-align: center;
      color: #2e7cd4;
      margin: 5px auto;
      cursor: pointer;
    }
  }

  .function {
    display: flex;
    justify-content: flex-end;
    padding-right: 50px;

    .form_bottom {
      display: inline-block;
      width: 146px;
      height: 39px;
      text-align: center;
      background: #ffffff;
      border: 2px solid #2a2a2a;
      border-radius: 21px;
      cursor: pointer;
      font-size: 16px;
      font-family: Source Han Sans CN, Source Han Sans CN-Regular;
      font-weight: 400;
      color: #2a2a2a;
      margin: 0 10px;
    }

    .black {
      background-color: #2a2a2a;
      color: #fff;
    }
  }
}

@{deep} .el-form-item__label {
  font-size: 14px;
  font-family: Source Han Sans CN, Source Han Sans CN-Regular;
  font-weight: 400;
  color: #707070;
}
</style>
